import QueryHandler from './QueryHandler';

export default QueryHandler;
